// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import axios from "axios";
// import Branches from "./Branches";

// function Newform() {
//   const [ContactDetail, setContactDetail] = useState([]);
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   const [formData, setFormData] = useState({
//     company_name: "",
//     contact_person: "",
//     form_address: "",
//     form_email: "",
//     form_city: "",
//     country_code: "+91",
//     mobile_number: "",
//     form_message: "",
//     privacy_policy: "0",
//   });

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: type === "checkbox" ? (checked ? "1" : "0") : value,
//     }));
//   };

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await axios.get(
//           "https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/contact_list"
//         );
//         setContactDetail(response.data.data);
//       } catch (error) {
//         console.error("Error fetching contact data:", error);
//       }
//     };
//     fetchData();
//   }, []);

//   const handleSubmitForm = async (e) => {
//     e.preventDefault();
//     setIsSubmitting(true);

//     try {
//       const payload = {
//         company_name: formData.company_name,
//         contact_person: formData.contact_person,
//         form_address: formData.form_address,
//         form_email: formData.form_email,
//         form_city: formData.form_city,
//         country_code: formData.country_code,
//         mobile_number: formData.mobile_number.replace(/^0+/, ""),
//         form_message: formData.form_message,
//         privacy_policy: formData.privacy_policy === "1",
//       };

//       console.log("Submitting payload:", payload);

//       const response = await axios.post(
//         "https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/add_contact_form",
//         payload,
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       console.log("API Response:", response.data);

//       if (response.data.success === 1 || response.data.status === true) {
//         alert("Form submitted successfully!");
//         setFormData({
//           company_name: "",
//           contact_person: "",
//           form_address: "",
//           form_email: "",
//           form_city: "",
//           country_code: "+91",
//           mobile_number: "",
//           form_message: "",
//           privacy_policy: "0",
//         });
//       } else {
//         alert(response.data.message || "Submission failed!");
//       }
//     } catch (error) {
//       console.error("Submission error:", error);
//       alert("Something went wrong, please try again.");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   return (
//     <section className="contact-section">
//       <div
//         className="container-fluid contact-top"
//         data-aos="fade-down"
//         data-aos-delay={40}
//       >
//         <h1>Have A Project Or Partnership In Mind?</h1>
//         <h4>Get in Touch</h4>
//       </div>

//       <div className="container">
//         <div className="row">
//           {/* Contact Details */}
//           {ContactDetail.map((Data, index) => (
//             <div className="col-lg-5 col-md-12 col-sm-12 col-12" key={index}>
//               <div
//                 className="contact_content"
//                 data-aos="fade-right"
//                 data-aos-delay={100}
//               >
//                 <div className="contact-box">
//                   <div className="box-image">
//                     <figure className="contact-location">
//                       <img
//                         src="img/location1.png"
//                         alt="location"
//                         className="img-fluid"
//                       />
//                     </figure>
//                   </div>
//                   <div className="box-content">
//                     <h4>Location:</h4>
//                     <p className="text">{Data.location}</p>
//                   </div>
//                 </div>

//                 <div className="contact-box">
//                   <div className="box-image">
//                     <figure className="contact-email">
//                       <img src="img/email.png" alt="email" className="img-fluid" />
//                     </figure>
//                   </div>
//                   <div className="box-content">
//                     <h4 className="heading">Email:</h4>
//                     <p>
//                       <a
//                         href={`mailto:${Data.email}`}
//                         className="text-decoration-none"
//                       >
//                         {Data.email}
//                       </a>
//                     </p>
//                   </div>
//                 </div>

//                 <div className="contact-box box-mb">
//                   <div className="box-image">
//                     <figure className="contact-phone">
//                       <img src="img/headphone.png" alt="phone" className="img-fluid" />
//                     </figure>
//                   </div>
//                   <div className="box-content">
//                     <h4 className="heading">Phone:</h4>
//                     <p>
//                       <a
//                         href={`tel:${Data.phone1}`}
//                         className="text-decoration-none text"
//                       >
//                         {Data.phone1}
//                       </a>
//                     </p>
//                     <p>
//                       <a
//                         href={`tel:${Data.phone2}`}
//                         className="mb-0 text-decoration-none text"
//                       >
//                         {Data.phone2}
//                       </a>
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           ))}

//           {/* Branches Component - NOW IN PLACE OF CONTACT FORM */}
//           <div
//             className="col-lg-7 col-md-12 col-sm-12 col-12"
//             data-aos="fade-up"
//             data-aos-delay={100}
//           >
//             <Branches />
//           </div>

//           {/* Contact Form - NOW IN FULL WIDTH BELOW */}
//           <div className="col-12 mt-4">
//             <div className="need-section">
//               <div className="need_content">
//                 <h6>Write to us</h6>
//                 <h2>Send us a Message</h2>

//                 <form onSubmit={handleSubmitForm}>
//                   <div className="row">
//                     <div className="col-12">
//                       <div className="form-group mb-0">
//                         <input
//                           type="text"
//                           className="box300 form_style"
//                           placeholder="Company/Individual Name"
//                           name="company_name"
//                           value={formData.company_name}
//                           onChange={handleChange}
//                           required
//                         />
//                       </div>
//                     </div>

//                     <div className="col-lg-12">
//                       <div className="form-group mb-0">
//                         <input
//                           type="text"
//                           className="box300 form_style"
//                           placeholder="Contact Person"
//                           name="contact_person"
//                           value={formData.contact_person}
//                           onChange={handleChange}
//                           required
//                         />
//                       </div>
//                     </div>

//                     <div className="col-lg-12">
//                       <div className="form-group mb-0">
//                         <input
//                           type="text"
//                           className="box300 form_style"
//                           placeholder="Address"
//                           name="form_address"
//                           value={formData.form_address}
//                           onChange={handleChange}
//                           required
//                         />
//                       </div>
//                     </div>

//                     <div className="col-lg-12">
//                       <div className="form-group mb-0">
//                         <input
//                           type="email"
//                           className="box300 form_style"
//                           placeholder="Email"
//                           name="form_email"
//                           value={formData.form_email}
//                           onChange={handleChange}
//                           required
//                         />
//                       </div>
//                     </div>

//                     <div className="col-lg-12">
//                       <div className="form-group mb-0">
//                         <input
//                           type="text"
//                           className="box300 form_style"
//                           placeholder="City"
//                           name="form_city"
//                           value={formData.form_city}
//                           onChange={handleChange}
//                           required
//                         />
//                       </div>
//                     </div>

//                     <div className="col-lg-12">
//                       <div className="input-group">
//                         <select
//                           id="countryDropdown"
//                           className="form-control country-select"
//                           name="country_code"
//                           value={formData.country_code}
//                           onChange={handleChange}
//                         >
//                           <option value="+91">IND (+91)</option>
//                           <option value="+65">SGP (+65)</option>
//                           <option value="+43">AUT (+43)</option>
//                         </select>
//                         <input
//                           type="number"
//                           className="form-control country-select"
//                           placeholder="Mobile Number"
//                           name="mobile_number"
//                           value={formData.mobile_number}
//                           onChange={handleChange}
//                           required
//                         />
//                       </div>
//                     </div>

//                     <div className="col-12">
//                       <div className="check">
//                         <input
//                           type="checkbox"
//                           name="privacy_policy"
//                           checked={formData.privacy_policy === "1"}
//                           onChange={handleChange}
//                         />
//                         <span>
//                           I agree to the{" "}
//                           <Link to="/privacy" className="privacy">
//                             privacy policy
//                           </Link>
//                         </span>
//                       </div>
//                     </div>

//                     <div className="col-lg-12">
//                       <div className="form-group mb-0">
//                         <textarea
//                           className="box302 form_style"
//                           placeholder="Message"
//                           rows={3}
//                           name="form_message"
//                           value={formData.form_message}
//                           onChange={handleChange}
//                         />
//                       </div>
//                     </div>
//                   </div>

//                   <div className="manage-button text-center">
//                     <button
//                       type="submit"
//                       className="box301 text-white text-decoration-none"
//                       disabled={isSubmitting}
//                     >
//                       {isSubmitting ? "Submitting..." : "Submit"}
//                     </button>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <figure className="layer-bottom offer-bottomlayer mb-0"></figure>
//     </section>
//   );
// }

// export default Newform;


// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import axios from "axios";
// import Branches from "./Branches";

// function Newform() {
//   const [ContactDetail, setContactDetail] = useState([]);
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   const [formData, setFormData] = useState({
//     company_name: "",
//     contact_person: "",
//     form_address: "",
//     form_email: "",
//     form_city: "",
//     country_code: "+91",
//     mobile_number: "",
//     form_message: "",
//     privacy_policy: "0",
//   });

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: type === "checkbox" ? (checked ? "1" : "0") : value,
//     }));
//   };

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await axios.get(
//           "https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/contact_list"
//         );
//         setContactDetail(response.data.data);
//       } catch (error) {
//         console.error("Error fetching contact data:", error);
//       }
//     };
//     fetchData();
//   }, []);

//   const handleSubmitForm = async (e) => {
//     e.preventDefault();
//     setIsSubmitting(true);

//     try {
//       const payload = {
//         company_name: formData.company_name,
//         contact_person: formData.contact_person,
//         form_address: formData.form_address,
//         form_email: formData.form_email,
//         form_city: formData.form_city,
//         country_code: formData.country_code,
//         mobile_number: formData.mobile_number.replace(/^0+/, ""),
//         form_message: formData.form_message,
//         privacy_policy: formData.privacy_policy === "1",
//       };

//       const response = await axios.post(
//         "https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/add_contact_form",
//         payload,
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (response.data.success === 1 || response.data.status === true) {
//         alert("Form submitted successfully!");
//         setFormData({
//           company_name: "",
//           contact_person: "",
//           form_address: "",
//           form_email: "",
//           form_city: "",
//           country_code: "+91",
//           mobile_number: "",
//           form_message: "",
//           privacy_policy: "0",
//         });
//       } else {
//         alert(response.data.message || "Submission failed!");
//       }
//     } catch (error) {
//       console.error("Submission error:", error);
//       alert("Something went wrong, please try again.");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   return (
//     <section className="contact-section">
//       <div
//         className="container-fluid contact-top"
//         data-aos="fade-down"
//         data-aos-delay={40}
//       >
//         <h1>Have A Project Or Partnership In Mind?</h1>
//         <h4>Get in Touch</h4>
//       </div>

//       <div className="container">
//         <div className="row">

//           {/* 🔄 CONTACT FORM SHIFTED HERE (RIGHT SIDE) */}
//           <div
//             className="col-lg-7 col-md-12 col-sm-12 col-12"
//             data-aos="fade-up"
//             data-aos-delay={100}
//           >
//             <div className="need-section">
//               <div className="need_content">
//                 <h6>Write to us</h6>
//                 <h2>Send us a Message</h2>

//                 <form onSubmit={handleSubmitForm}>
//                   <div className="row">

//                     <div className="col-12">
//                       <div className="form-group mb-0">
//                         <input
//                           type="text"
//                           className="box300 form_style"
//                           placeholder="Company/Individual Name"
//                           name="company_name"
//                           value={formData.company_name}
//                           onChange={handleChange}
//                           required
//                         />
//                       </div>
//                     </div>

//                     <div className="col-lg-12">
//                       <div className="form-group mb-0">
//                         <input
//                           type="text"
//                           className="box300 form_style"
//                           placeholder="Contact Person"
//                           name="contact_person"
//                           value={formData.contact_person}
//                           onChange={handleChange}
//                           required
//                         />
//                       </div>
//                     </div>

//                     <div className="col-lg-12">
//                       <div className="form-group mb-0">
//                         <input
//                           type="text"
//                           className="box300 form_style"
//                           placeholder="Address"
//                           name="form_address"
//                           value={formData.form_address}
//                           onChange={handleChange}
//                           required
//                         />
//                       </div>
//                     </div>

//                     <div className="col-lg-12">
//                       <div className="form-group mb-0">
//                         <input
//                           type="email"
//                           className="box300 form_style"
//                           placeholder="Email"
//                           name="form_email"
//                           value={formData.form_email}
//                           onChange={handleChange}
//                           required
//                         />
//                       </div>
//                     </div>

//                     <div className="col-lg-12">
//                       <div className="form-group mb-0">
//                         <input
//                           type="text"
//                           className="box300 form_style"
//                           placeholder="City"
//                           name="form_city"
//                           value={formData.form_city}
//                           onChange={handleChange}
//                           required
//                         />
//                       </div>
//                     </div>

//                     <div className="col-lg-12">
//                       <div className="input-group">
//                         <select
//                           className="form-control country-select"
//                           name="country_code"
//                           value={formData.country_code}
//                           onChange={handleChange}
//                         >
//                           <option value="+91">IND (+91)</option>
//                           <option value="+65">SGP (+65)</option>
//                           <option value="+43">AUT (+43)</option>
//                         </select>

//                         <input
//                           type="number"
//                           className="form-control country-select"
//                           placeholder="Mobile Number"
//                           name="mobile_number"
//                           value={formData.mobile_number}
//                           onChange={handleChange}
//                           required
//                         />
//                       </div>
//                     </div>

//                     <div className="col-12">
//                       <div className="check">
//                         <input
//                           type="checkbox"
//                           name="privacy_policy"
//                           checked={formData.privacy_policy === "1"}
//                           onChange={handleChange}
//                         />
//                         <span>
//                           I agree to the{" "}
//                           <Link to="/privacy" className="privacy">
//                             privacy policy
//                           </Link>
//                         </span>
//                       </div>
//                     </div>

//                     <div className="col-lg-12">
//                       <div className="form-group mb-0">
//                         <textarea
//                           className="box302 form_style"
//                           placeholder="Message"
//                           rows={3}
//                           name="form_message"
//                           value={formData.form_message}
//                           onChange={handleChange}
//                         />
//                       </div>
//                     </div>
//                   </div>

//                   <div className="manage-button text-center">
//                     <button
//                       type="submit"
//                       className="box301 text-white text-decoration-none"
//                       disabled={isSubmitting}
//                     >
//                       {isSubmitting ? "Submitting..." : "Submit"}
//                     </button>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>

//           {/* 🔄 BRANCHES SAME RAHEGA (LEFT SIDE ME) */}
//           <div
//             className="col-lg-5 col-md-12 col-sm-12 col-12"
//             data-aos="fade-right"
//             data-aos-delay={100}
//           >
//             <Branches />
//           </div>

//           {/* 🔄 CONTACT DETAILS MOVED TO FULL WIDTH BELOW */}
//           <div className="col-12 mt-2 mb-5">
//             <div className="row">
//               {ContactDetail.map((Data, index) => (
//                 <div className="col-lg-12 col-md-6 col-sm-12" key={index}>
//                   <div className="contact_content">
//                     <div className="contact-box">
//                       <div className="box-image">
//                         <img src="img/location1.png" className="img-fluid" alt="" />
//                       </div>
//                       <div className="box-content">
//                         <h4>Location:</h4>
//                         <p>{Data.location}</p>
//                       </div>
//                     </div>

//                     <div className="contact-box">
//                       <div className="box-image">
//                         <img src="img/email.png" className="img-fluid" alt="" />
//                       </div>
//                       <div className="box-content">
//                         <h4>Email:</h4>
//                         <a href={`mailto:${Data.email}`}>{Data.email}</a>
//                       </div>
//                     </div>

//                     <div className="contact-box">
//                       <div className="box-image">
//                         <img src="img/headphone.png" className="img-fluid" alt="" />
//                       </div>
//                       <div className="box-content">
//                         <h4>Phone:</h4>
//                         <a href={`tel:${Data.phone1}`}>{Data.phone1}</a>
//                         <br />
//                         <a href={`tel:${Data.phone2}`}>{Data.phone2}</a>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>

//         </div>
//       </div>

//       <figure className="layer-bottom offer-bottomlayer mb-0"></figure>
//     </section>
//   );
// }

// export default Newform;

// Before my 1st nlf meeting 7 feb 2026 start
// Before my 1st nlf meeting 7 feb 2026 start
// Before my 1st nlf meeting 7 feb 2026 start
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Branches from "./Branches";
import "./contact.css";
import SEO from "../Component/SEO";

// ---- Inline icons (no external icon library needed) ----
const iconBase = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.8,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

const MapPinIcon = ({ size = 20, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" className={className} {...iconBase}>
    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

const PhoneIcon = ({ size = 20, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" className={className} {...iconBase}>
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.362 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.338 1.85.573 2.81.7A2 2 0 0 1 22 16.92Z" />
  </svg>
);

const MailIcon = ({ size = 20, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" className={className} {...iconBase}>
    <rect x="2" y="4" width="20" height="16" rx="2" />
    <path d="m2 6 10 7 10-7" />
  </svg>
);

const ExternalLinkIcon = ({ size = 14, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" className={className} {...iconBase}>
    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
    <path d="M15 3h6v6" />
    <path d="M10 14 21 3" />
  </svg>
);

const UserIcon = ({ size = 18, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" className={className} {...iconBase}>
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);

const PencilIcon = ({ size = 18, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" className={className} {...iconBase}>
    <path d="M12 20h9" />
    <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z" />
  </svg>
);

const SendIcon = ({ size = 18, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" className={className} {...iconBase}>
    <path d="m22 2-7 20-4-9-9-4Z" />
    <path d="M22 2 11 13" />
  </svg>
);

const ShareIcon = ({ size = 16, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" className={className} {...iconBase}>
    <circle cx="18" cy="5" r="3" />
    <circle cx="6" cy="12" r="3" />
    <circle cx="18" cy="19" r="3" />
    <path d="m8.6 13.5 6.8 4M15.4 6.5l-6.8 4" />
  </svg>
);

const ExpandIcon = ({ size = 16, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" className={className} {...iconBase}>
    <path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7" />
  </svg>
);

const ChevronDownIcon = ({ size = 14, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" className={className} {...iconBase}>
    <path d="m6 9 6 6 6-6" />
  </svg>
);

const COUNTRY_OPTIONS = [
  { code: "+91", flag: "🇮🇳", label: "IND" },
  { code: "+65", flag: "🇸🇬", label: "SGP" },
  { code: "+43", flag: "🇦🇹", label: "AUT" },
];

function Newform() {
  const [ContactDetail, setContactDetail] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [countryOpen, setCountryOpen] = useState(false);

  const [formData, setFormData] = useState({
    company_name: "",
    contact_person: "",
    form_address: "",
    form_email: "",
    form_city: "",
    country_code: "+91",
    mobile_number: "",
    form_message: "",
    privacy_policy: "0",
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? (checked ? "1" : "0") : value,
    }));
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/contact_list"
        );
        setContactDetail(response.data.data);
      } catch (error) {
        console.error("Error fetching contact data:", error);
      }
    };
    fetchData();
  }, []);

  const handleSubmitForm = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const payload = {
        company_name: formData.company_name,
        contact_person: formData.contact_person,
        form_address: formData.form_address,
        form_email: formData.form_email,
        form_city: formData.form_city,
        country_code: formData.country_code,
        mobile_number: formData.mobile_number.replace(/^0+/, ""),
        form_message: formData.form_message,
        privacy_policy: formData.privacy_policy === "1",
      };

      const response = await axios.post(
        "https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/add_contact_form",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success === 1 || response.data.status === true) {
        alert("Form submitted successfully!");
        setFormData({
          company_name: "",
          contact_person: "",
          form_address: "",
          form_email: "",
          form_city: "",
          country_code: "+91",
          mobile_number: "",
          form_message: "",
          privacy_policy: "0",
        });
      } else {
        alert(response.data.message || "Submission failed!");
      }
    } catch (error) {
      console.error("Submission error:", error);
      alert("Something went wrong, please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  // Head office is the first record returned by the API
  const office = ContactDetail[0] || {};
  const selectedCountry =
    COUNTRY_OPTIONS.find((c) => c.code === formData.country_code) || COUNTRY_OPTIONS[0];

  return (
    <section className="contact-section">
      <div className="container">
        <div className="row contact-row">
          <SEO
        title="Contact NLF Solutions | Offices in Nagpur, Mumbai & India"
        description="Contact NLF Solutions for architectural and building solutions through our offices in Nagpur, New Delhi, Mumbai, Pune, Indore, Kolkata and Raipur."
        canonical="https://nlfs.in/gallery"
        // keywords="Architectural Project Gallery, NLF projects, Architectural projects, Completed projects, Facade projects, Interior projects, Ceiling projects, Project portfolio, architectural projects in India, architectural project gallery, commercial architectural projects, completed architectural projects"
      />
      <h1 className="seo-h1">Our Architectural Projects</h1>
          {/* ===== LEFT COLUMN: Title + Head office + Branches ===== */}
          <div className="col-lg-6 col-md-12" data-aos="fade-right" data-aos-delay={120}>
            <div className="contact-top" data-aos="fade-down" data-aos-delay={40}>
              <p className="eyebrow">LET'S CONNECT</p>
              <h1>
                Contact <span className="accent">Us</span>
              </h1>
              <p className="lead-text">
                We'd love to hear from you. Whether you have a question, need support, or
                want to discuss a project, our team is here to help.
              </p>
            </div>

            <div className="head-office-box">
              <div className="office-grid">
                <div className="office-item office-item--location">
                  <span className="office-icon">
                    <MapPinIcon />
                  </span>
                  <div className="office-item-body">
                    <h4>Head Office</h4>
                    <p>
                      {office.location ||
                        "Plot #6, New Corporation Colony, North Ambajhari Road, Nagpur - 440 010, India"}
                    </p>
                    <a
                      href={"https://maps.app.goo.gl/bz9oFFx88jAvrPtWA"}
                      className="view-map"
                      target="_blank"
                      rel="noreferrer"
                    >
                     View on Map <ExternalLinkIcon />
                    </a>
                  </div>
                </div>

                <div className="office-item-stack">
                  <div className="office-item">
                    <span className="office-icon">
                      <PhoneIcon />
                    </span>
                    <div className="office-item-body">
                      <h4>Phone</h4>
                      <a href={`tel:${office.phone1 || "+917122225435"}`}>
                        {office.phone1 || "+91 712 222 5435"}
                      </a>
                    </div>
                  </div>

                  <div className="office-item">
                    <span className="office-icon">
                      <MailIcon />
                    </span>
                    <div className="office-item-body">
                      <h4>Email</h4>
                      <a href={`mailto:${office.email || "info@yourcompany.com"}`}>
                        {office.email || "info@yourcompany.com"}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <Branches />
          </div>

          {/* ===== RIGHT COLUMN: Form + Map ===== */}
          <div className="col-lg-6 col-md-12 mt-0" data-aos="fade-up" data-aos-delay={100}>
            <div className="need-section">
              <h2>Send us a Message</h2>

              <form onSubmit={handleSubmitForm}>
                <div className="form-grid">
                  <div className="field-icon">
                    <UserIcon className="field-icon-svg" />
                    <input
                      type="text"
                      placeholder="Company / Individual Name"
                      name="company_name"
                      value={formData.company_name}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="field-icon">
                    <UserIcon className="field-icon-svg" />
                    <input
                      type="text"
                      placeholder="Contact Person"
                      name="contact_person"
                      value={formData.contact_person}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="field-icon">
                    <MailIcon className="field-icon-svg" />
                    <input
                      type="email"
                      placeholder="Email"
                      name="form_email"
                      value={formData.form_email}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="field-icon mobile-field">
                    <PhoneIcon className="field-icon-svg" />
                    <div className="country-dropdown">
                      <button
                        type="button"
                        className="country-toggle"
                        onClick={() => setCountryOpen((o) => !o)}
                      >
                        <span>{selectedCountry.flag}</span>
                        <span>{selectedCountry.code}</span>
                        <ChevronDownIcon />
                      </button>
                      {countryOpen && (
                        <ul className="country-menu">
                          {COUNTRY_OPTIONS.map((c) => (
                            <li
                              key={c.code}
                              onClick={() => {
                                setFormData((prev) => ({ ...prev, country_code: c.code }));
                                setCountryOpen(false);
                              }}
                            >
                              <span>{c.flag}</span> {c.label} ({c.code})
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                    <input
                      type="text"
                      placeholder="Mobile Number"
                      name="mobile_number"
                      value={formData.mobile_number}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="field-icon field-full">
                    <MapPinIcon className="field-icon-svg" />
                    <input
                      type="text"
                      placeholder="Address"
                      name="form_address"
                      value={formData.form_address}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="field-icon field-full">
                    <MapPinIcon className="field-icon-svg" />
                    <input
                      type="text"
                      placeholder="City"
                      name="form_city"
                      value={formData.form_city}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="field-icon field-full field-textarea">
                    <PencilIcon className="field-icon-svg" />
                    <textarea
                      placeholder="Your Message"
                      rows={3}
                      name="form_message"
                      value={formData.form_message}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="field-full check">
                    <input
                      type="checkbox"
                      id="privacy_policy"
                      name="privacy_policy"
                      checked={formData.privacy_policy === "1"}
                      onChange={handleChange}
                    />
                    <label htmlFor="privacy_policy">
                      I agree to the{" "}
                      <Link to="/privacy" className="privacy">
                        Privacy Policy
                      </Link>
                    </label>
                  </div>
                </div>

                <button type="submit" className="submit-btn" disabled={isSubmitting}>
                  {isSubmitting ? "Submitting..." : "Send Message"} <SendIcon />
                </button>
              </form>
            </div>

            <div className="map-container">
              <iframe
                title="NLF Office Location"
                src="https://www.google.com/maps/d/u/0/embed?mid=17SQw3aeDD1TiQXIzeamJhwnmxTMaFLM&ehbc=2E312F"
                width="100%"
                height="450"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Newform;